import React from 'react';
import './pages.css';

const Personal = () => {
  return (
    <div className="page-container personal-page">
      <div className="personal-content">
        <h1 className="animated-title">Personal</h1>
        
        <div className="personal-intro centered-intro">
          <p className="intro-text">Hey, thanks for checking out my website! :&#41;</p>
          <p className="intro-text">If you're curious about my personal life, here's a bit more about me:</p>
        </div>
        
        <div className="personal-sections">
          <div className="personal-section fade-in" style={{animationDelay: '0.1s'}}>
            <div className="section-header">
              <span className="section-icon">🏆</span>
              <h2>Sports</h2>
            </div>
            <ul className="no-hover-movement">
              <li>Ultimate Frisbee Intramurals, Spikeball Intramurals</li>
              <li>Lots of running</li>
              <li>Former Rhythmic Gymnastics Coach</li>
              <li>Former Team Canada Member Aesthetic Group Gymnastics </li>
        
            </ul>
          </div>
          
          <div className="personal-section fade-in" style={{animationDelay: '0.2s'}}>
            <div className="section-header">
              <span className="section-icon">🎨</span>
              <h2>Art</h2>
            </div>
            <ul className="no-hover-movement">
              <li>Former Part Time Competitive Dancer (2019-2021) - Acro, Lyrical, Contemporary, Ballet, Jazz, and Hip Hop</li>
              <li>Felting - I've felted llamas, pandas, and mystical creatures</li>
            </ul>
          </div>
          
          <div className="personal-section fade-in" style={{animationDelay: '0.3s'}}>
            <div className="section-header">
              <span className="section-icon">✈️</span>
              <h2>Countries I've Visited</h2>
            </div>
            <div className="countries-list">
              <div className="region">
                <h3 className="region-name">Americas</h3>
                <p className="countries-group">Canada, USA, The Bahamas, Saint Kitts and Nevis, Costa Rica, Cuba, Dominican Republic, Mexico</p>
              </div>
              <div className="region">
                <h3 className="region-name">Europe</h3>
                <p className="countries-group">Italy, Spain, Czech Republic, Austria, United Kingdom, France, Finland, Greece</p>
              </div>
              <div className="region">
                <h3 className="region-name">Asia</h3>
                <p className="countries-group">Malaysia, Türkiye</p>
              </div>
            </div>
          </div>
          
          <div className="personal-section fade-in" style={{animationDelay: '0.4s'}}>
            <div className="section-header">
              <span className="section-icon">📚</span>
              <h2>Favourite Places in Waterloo</h2>
            </div>
            <ul className="no-hover-movement">
              <li>Williams Cafe (I actually have an addiction)</li>
              <li>Midnight Run Cafe</li>
              <li>Foodie Fruttie</li>
              <li>Woodsworth Books</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Personal; 